import {
  ADD_COMMENT_TO_INTERVENTION,
  EDIT_INTERVENTION,
  HANDLE_UPDATE_INTERVENTION_RESPONSE,
  INTERVENTION_STUDENTS_LIST_LOADING,
  INTERVENTION_STUDENTS_LIST_NOT_LOADING,
  RESET_AND_SCROLL_INTERVENTION,
  RESET_INTERVENTION_MODULE,
  SAVE_DELETED_INTERVENTION_ID,
  SET_DRAWER_COMPONENT,
  SET_DRAWER_STATE,
  SET_EXEMPTION_REASONS_LIST,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_INTERVENTION_ACTION,
  SET_INTERVENTION_CATEGORY,
  SET_INTERVENTION_CATEGORY_LIST,
  SET_INTERVENTION_CLOSURE_LIST,
 // SET_INTERVENTION_COMMENT,
  SET_INTERVENTION_COMMUNICATION,
  SET_INTERVENTION_COMMUNICATION_LIST,
  SET_INTERVENTION_COMMUNICATION_DATE,
  SET_INTERVENTION_COMMUNICATION_DATE_FORMATTED,
  SET_INTERVENTION_COUNT,
  SET_INTERVENTION_DATE,
  SET_INTERVENTION_DATE_FORMATTED,
  SET_INTERVENTION_FORM_VALID,
  SET_INTERVENTION_REFERRAL,
  SET_INTERVENTION_REFERRAL_LIST,
  SET_INTERVENTION_REMINDER_DAYS,
  SET_INTERVENTION_REPEATING_EMAIL,
  SET_INTERVENTION_SENDING,
  SET_INTERVENTION_STUDENT,
  SET_INTERVENTION_STUDENTS,
  SET_INTERVENTION_SUMMARY,
  SET_INTERVENTION_DURATION,
  SET_INTERVENTION_DESCRIPTION,
  SET_INTERVENTION_CLOSE_ON_CREATE,
  SET_INTERVENTION_CONSENT,
  SET_SELECTED_RECIPIENT_USER_TYPES,
  SET_INTERVENTION_RECIPIENT_TYPES,
  CONCAT_INTERVENTION_RECIPIENT_TYPES, SET_INTERVENTION_INVALID_EMAIL_STATUS, RESET_INTERVENTION_RECIPIENT_TYPES
} from '../mutation-types'
import {
  GET_DROPDOWN_VALUES,
  GET_INTERVENTION_STUDENTS_LIST,
  POST_INTERVENTION_COMMENT,
  POST_INTERVENTION_FORM,
  REPLACE_STUDENT_INTERACTIONS, RESET_INTERVENTION_MODULES,
  UPDATE_INTERACTIONS_PAGE
} from '../action-types'
import axios from 'axios/index'
import moment from 'moment-es6'
import { informationTexts } from './information'
import { GET_SELECTED_REFERRAL_OBJECT } from '../getter-types'

const variableLists = {
  categories: [],
  communications: [],
  closureReasons: [],
  referrals: [],
  lastDeletedId: null,
  recipientTypes: [],
  originalRecipientTypes: []
}

const state = () => ({
  interventionCategorySelected: null,
  referralSelected: null,
  selectedStudent: '',
  selectedCommunication: '',
  dateOfCommunication: moment().format('YYYY-MM-DD'),
  dateOfCommunicationFormatted: moment().format('DD/MM/YYYY'),
  meetingDuration: 0,
  description: null,
  closeOnCreation: false,
  consent: false,
  reminderInDays: 0,
  repeatingEmail: false,
  date: null,
  dateFormatted: null,
  action: '',
  comment: '',
  summary: '',
  loading: false,
  snackbar: false,
  students: [],
  valid: true,
  sending: false,
  interventionId: null,
  selectedUserRecipients: [],
  invalidFreestyleEmail: false,
  emailReg: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/,
  counts: {
    inProgress: 0,
    isNew: 0,
    delayed: 0
  },
  functions: {
    interventionForm: 'INTERVENFM'
  },
  options: {
    enable: {
      singleInterventionCategory: 'ENBSIINCAT',
      referralConsent: 'ENBREFCON'
    }
  }
})

const mutations = {
  [SET_SELECTED_RECIPIENT_USER_TYPES] (state, value) {
    state.selectedUserRecipients = value
  },
  [SET_INTERVENTION_RECIPIENT_TYPES] (state, types) {
    state.recipientTypes = types
    state.originalRecipientTypes = types
  },
  [CONCAT_INTERVENTION_RECIPIENT_TYPES] (state, type) {
    state.recipientTypes = state.recipientTypes.concat(type)
  },
  [SET_INTERVENTION_INVALID_EMAIL_STATUS] (state, status) {
    state.invalidFreestyleEmail = status
  },
  [SET_INTERVENTION_CATEGORY] (state, value) {
    state.interventionCategorySelected = value
  },
  [SET_INTERVENTION_STUDENT] (state, value) {
    state.selectedStudent = value
  },
  [SET_INTERVENTION_COMMUNICATION] (state, value) {
    state.selectedCommunication = value
  },
  [SET_INTERVENTION_REMINDER_DAYS] (state, value) {
    state.reminderInDays = value
  },
  [SET_INTERVENTION_REPEATING_EMAIL] (state, value) {
    state.repeatingEmail = value
  },
  [SET_INTERVENTION_DATE] (state, value) {
    state.date = value
  },
  [SET_INTERVENTION_DATE_FORMATTED] (state, value) {
    state.dateFormatted = value
  },
  [SET_INTERVENTION_COMMUNICATION_DATE] (state, value) {
    state.dateOfCommunication = value
  },
  [SET_INTERVENTION_COMMUNICATION_DATE_FORMATTED] (state, value) {
    state.dateOfCommunicationFormatted = value
  },
  [SET_INTERVENTION_ACTION] (state, value) {
    state.action = value
  },
  [SET_INTERVENTION_SUMMARY] (state, value) {
    state.summary = value
  },
  [SET_INTERVENTION_STUDENTS] (state, students) {
    let list = []
    students.forEach((student) => {
      if (student.studentMatch) {
        list.push({
          text: student.studentMatch,
          value: student.id
        })
      } else {
        list.push({
          text: `${student.firstName} ${student.lastName} - ${student.displayId}`,
          value: student.id
        })
      }
    })
    state.students = list
  },
  [INTERVENTION_STUDENTS_LIST_LOADING] (state) {
    state.loading = true
  },
  [INTERVENTION_STUDENTS_LIST_NOT_LOADING] (state) {
    state.loading = false
  },
  [SET_INTERVENTION_FORM_VALID] (state, value) {
    state.valid = value
  },
  [SET_INTERVENTION_CATEGORY_LIST] (state, list) {
    state.categories = list.map(mapServerToLocal)
  },
  [SET_INTERVENTION_COMMUNICATION_LIST] (state, list) {
    state.communications = list.map(mapServerToLocal)
  },
  [SET_INTERVENTION_CLOSURE_LIST] (state, list) {
    state.closureReasons = list.map(mapServerToLocal)
  },
  [SET_INTERVENTION_REFERRAL_LIST] (state, list) {
    state.referrals = list.map(mapServerToLocal)
    state.referrals.unshift({
      text: 'no_referral',
      value: null,
      url: null,
      urlKey: null
    })
    state.referrals.map(ref => {
      ref.text = `referral.${ref.text}`
      return ref
    })
  },
  [SET_INTERVENTION_SENDING] (state, value) {
    state.sending = value
  },
  [RESET_INTERVENTION_MODULE] (s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
  },
  [RESET_INTERVENTION_RECIPIENT_TYPES] (state) {
    state.recipientTypes = state.originalRecipientTypes
  },
  [EDIT_INTERVENTION] (state, intervention) {
    if (intervention.recipients) {
      state.recipientTypes = state.recipientTypes.concat(mapFreestyleRecipients(intervention.recipients))
      state.selectedUserRecipients = mapSelectedRecipients(intervention.recipients)
    }
    state.interventionCategorySelected = intervention.category.id
    state.selectedStudent = intervention.student.id
    state.students = [{
      text: intervention.student.firstName + ' ' + intervention.student.lastName,
      value: intervention.student.id
    }]
    state.selectedCommunication = intervention.communicationApproach.id
    state.reminderInDays = intervention.reminderEmailFrequency
    state.date = moment(intervention.actionTargetDate).format('YYYY-MM-DD')
    state.dateFormatted = moment(intervention.actionTargetDate).format('DD/MM/YYYY')
    state.action = intervention.studentAction
    state.referralSelected = intervention.referee ? intervention.referee.refereeId : undefined
    state.interventionId = intervention.id
    state.repeatingEmail = intervention.repeatingEmail
    state.creationDate = intervention.creationDate
    state.meetingDuration = intervention.meetingDuration
    state.description = intervention.description
    state.dateOfCommunication = intervention.dateOfCommunication
    if (state.dateOfCommunication) {
      state.dateOfCommunication = moment(state.dateOfCommunication).format('YYYY-MM-DD')
      state.dateOfCommunicationFormatted = moment(state.dateOfCommunication).format('DD/MM/YYYY')
    } else {
      state.dateOfCommunicationFormatted = null
    }
  },
  [SAVE_DELETED_INTERVENTION_ID] (state, id) {
    state.lastDeletedId = id
  },
  [SET_INTERVENTION_REFERRAL] (state, value) {
    state.referralSelected = value
  },
  [SET_INTERVENTION_COUNT] (state, counts) {
    state.counts = counts
  },
  [SET_INTERVENTION_DURATION] (state, duration) {
    state.meetingDuration = duration
  },
  [SET_INTERVENTION_DESCRIPTION] (state, description) {
    state.description = description
  },
  [SET_INTERVENTION_CLOSE_ON_CREATE] (state, value) {
    state.closeOnCreation = value
  },
  [SET_INTERVENTION_CONSENT] (state, value) {
    state.consent = value
  }
}

const actions = {
  [GET_INTERVENTION_STUDENTS_LIST] ({rootState, commit}, value) {
    if (value.length < 3) return
    commit(INTERVENTION_STUDENTS_LIST_LOADING)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/match/${value}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: GET_INTERVENTION_STUDENTS_LIST, data: value }
    })
      .then((res) => {
        commit(INTERVENTION_STUDENTS_LIST_NOT_LOADING)
        commit(SET_INTERVENTION_STUDENTS, res.data)
      })
      .catch((err) => {
        commit(INTERVENTION_STUDENTS_LIST_NOT_LOADING)
        console.error(err)
      })
  },
  [GET_DROPDOWN_VALUES] ({rootState, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/custom_list/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: GET_DROPDOWN_VALUES }
    })
      .then((res) => {
        commit(SET_INTERVENTION_CATEGORY_LIST, res.data.categories)
        commit(SET_INTERVENTION_COMMUNICATION_LIST, res.data.communicationApproaches)
        commit(SET_INTERVENTION_CLOSURE_LIST, res.data.closureReasons)
        commit(SET_EXEMPTION_REASONS_LIST, res.data.exemptionReasons)
        commit(SET_INTERVENTION_REFERRAL_LIST, res.data.referees)
        let obj = res.data.interventionRecipientTypes.map(el => {
          return {
            text: 'intervention_recipients.types.' + el.description.toLowerCase(),
            value: el.description
          }
        })
        commit(SET_INTERVENTION_RECIPIENT_TYPES, obj)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [POST_INTERVENTION_FORM] ({rootState, state, commit, dispatch}, payload) {
    commit(SET_INTERVENTION_SENDING, true)
    let url, method
    if (state.interventionId) {
      url = `${rootState.config.baseUrl}:${rootState.config.port}/core/intervention/${state.interventionId}/student/${payload.studentId}`
      method = 'put'
    } else {
      url = `${rootState.config.baseUrl}:${rootState.config.port}/core/intervention/${payload.studentId}`
      method = 'post'
    }
    axios({
      url: url,
      method: method,
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: POST_INTERVENTION_FORM, data: payload }
    })
      .then((res) => {
        commit(SET_INTERVENTION_SENDING, false)
        if (!state.interventionId) {
          commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.INTERVENTION_CREATED)
        } else {
          commit(HANDLE_UPDATE_INTERVENTION_RESPONSE, res.data)
          commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.INTERVENTION_UPDATED)
          commit(RESET_AND_SCROLL_INTERVENTION, state.interventionId)
        }
        commit(RESET_INTERVENTION_MODULE)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_DRAWER_COMPONENT, null)
        commit(SET_DRAWER_STATE, false)
        dispatch(UPDATE_INTERACTIONS_PAGE)
        const studentId = rootState.student.student.id
        if (studentId && res.data.student.id === studentId) {
          dispatch(REPLACE_STUDENT_INTERACTIONS, studentId)
        }
      })
      .catch((err) => {
        console.error(err)
        commit(SET_INTERVENTION_SENDING, false)
        if (hasInvalidEmail(err)) {
          commit(SET_INTERVENTION_INVALID_EMAIL_STATUS, true)
        }
      })
  },
  [POST_INTERVENTION_COMMENT] ({rootState, state, commit}, payload) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/intervention/comment/${payload.id}`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: POST_INTERVENTION_COMMENT, data: payload }
    })
      .then((res) => {
        commit(ADD_COMMENT_TO_INTERVENTION, res.data)
        commit(RESET_AND_SCROLL_INTERVENTION, payload.id)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [RESET_INTERVENTION_MODULES] ({state, commit}) {
    commit(RESET_INTERVENTION_MODULE)
    commit(RESET_INTERVENTION_RECIPIENT_TYPES)
  }
}

const getters = {
  [GET_SELECTED_REFERRAL_OBJECT]: state => {
    return state.referrals.find(el => {
      return el.value === state.referralSelected
    })
  }
}

function mapServerToLocal (object) {
  return {
    text: object.description,
    value: object.id,
    url: object.url || null,
    urlKey: object.urlKey || null
  }
}

export const mapSelectedRecipients = (obj) => {
  return obj.map(el => {
    if (el.type === 'FREESTYLE') {
      return el.email
    } else {
      return el.type
    }
  })
}

export const mapFreestyleRecipients = (obj) => {
  return obj.filter(el => el.type === 'FREESTYLE').map(el => {
    return {
      text: el.email,
      value: el.email
    }
  })
}

export const hasInvalidEmail = (error) => {
  if (error.response.data.childErrors) {
    return error.response.data.childErrors.filter(el => el.errorType === 'VALIDATION_INTERVENTION_RECIPIENT_INVALID_EMAIL_ADDRESS')
  }
  return false
}

export default {
  state: Object.assign({}, state(), variableLists),
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/intervention.js